import { Record } from 'immutable';
import WineProfile from './WineProfile';
import { formatCurrency } from '../../client/lib/utils';

const WineSkuDefaults = {
  id: null,
  wine_profile: null,
  volume_text: null,
  offers: [],
  slug: null
};

class WineSku extends Record(WineSkuDefaults) {
  constructor(values) {
    values.wine_profile = (values.wine_profile instanceof WineProfile) ? values.wine_profile : new WineProfile(values.wine_profile);
    super(values);
  }

  get price_range_text() {
    if(!this.offers.length) {return null;}
    let min, max;
    this.offers.forEach((offer) => {
      if(!min || offer.price_in_cents < min) {
        min = offer.price_in_cents;
      }
      if(!max || offer.price_in_cents > max) {
        max = offer.price_in_cents;
      }
    });
    if(min && max) {
      return `${formatCurrency(min)}`;
    }
    return `${formatCurrency(min)} - ${formatCurrency(max)}`;
  }
}

export default WineSku;



// WEBPACK FOOTER //
// banquet/models/WineSku.js